/**
 * The header search's icon opens the field and, once open, closes it again.
 *
 * Core's button-only search opens on the icon and then makes the icon its
 * submit button. Here the field has a search button of its own
 * (lib/navigation.php), so while the field is open the icon is a cross that
 * closes it -- through core's own Escape handling, which closes the field and
 * puts focus back on the icon. The form gets .is-search-open for the cross
 * (components/_header.scss) and its label from data-close-label.
 */
export function initHeaderSearch() {
	document.querySelectorAll('.diakon-header__search').forEach((form) => {
		const button = form.querySelector('.wp-block-search__button');

		if (!button) {
			return;
		}

		const isOpen = () =>
			!form.classList.contains('wp-block-search__searchfield-hidden');

		const sync = () => {
			form.classList.toggle('is-search-open', isOpen());

			if (isOpen() && form.dataset.closeLabel) {
				button.setAttribute('aria-label', form.dataset.closeLabel);
			}
		};

		// Capture, so it runs before core's own click handler and the submit.
		button.addEventListener(
			'click',
			(event) => {
				if (!isOpen()) {
					return;
				}

				event.preventDefault();
				event.stopImmediatePropagation();
				form.dispatchEvent(
					new window.KeyboardEvent('keydown', {
						key: 'Escape',
						bubbles: true,
					})
				);
			},
			true
		);

		new window.MutationObserver(sync).observe(form, {
			attributes: true,
			attributeFilter: ['class'],
		});
	});
}
